export default {"src":"/_next/static/media/Group50.b01cba38.svg","height":26,"width":106};